export class Common {
  public static commons: any = {
    timeout: 50000,
    country: 'CO',
    commerce: 'Banco',
    productId: 'CJ-ACC'
  };
}
